/**
 * layoutConstants — shared measurements for the fixed-header + sticky-sidebar
 * + window-scroll shell model (mirrors the reference app aies-intake).
 *
 * Both shells (public AppLayout, authenticated AuthenticatedLayout) put their
 * header in `position: fixed` (out of normal flow), so the shell root
 * compensates with `paddingTop: HEADER_HEIGHT`.
 */

import type { CSSProperties } from 'react';

// Must match each header's inner height. The header is `position: fixed`, so the
// shell root pads its top by this amount to make room for it.
export const HEADER_HEIGHT_PX = 64;
export const HEADER_HEIGHT = `${HEADER_HEIGHT_PX}px`;

// The body row's own top padding. The nav drawer's rest position is
// `HEADER_HEIGHT + BODY_PADDING_TOP` below the document top, so its sticky `top`
// MUST equal that same offset — otherwise the drawer scrolls up by exactly
// BODY_PADDING_TOP before it reaches the sticky threshold and pins (the "slight
// upward jump on first scroll" bug). Matching them = zero travel.
export const BODY_PADDING_TOP_PX = 24;
export const NAV_STICKY_TOP_PX = HEADER_HEIGHT_PX + BODY_PADDING_TOP_PX; // 88

// Fluent's InlineDrawer sets its own `position: relative` via a low-priority
// `makeResetStyles` rule, whose precedence against a plain `makeStyles` override
// isn't reliable in practice — an inline style always wins regardless, so the
// sticky positioning is applied inline instead of via a Griffel class
// (desktop/inline drawer type only).
export const INLINE_DRAWER_STICKY_STYLE: CSSProperties = {
  position: 'sticky',
  top: `${NAV_STICKY_TOP_PX}px`,
  alignSelf: 'flex-start',
  height: `calc(100vh - ${NAV_STICKY_TOP_PX}px)`,
  // Narrower than Fluent's 260px default — enough for the short nav labels.
  // Inline style (not a Griffel class) so it reliably beats the drawer's own
  // reset-style width. Overlay (mobile) drawer keeps its default width.
  width: '180px',
};
